import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./index.css";

// Redux Imports
import { MisReportCreateDownload } from "../../../redux/features/scheduleTransaction";

// Components Imports
import PrimaryStepper from "../../../components/_utils/CommonSteppers/PrimaryStepper";
import CommonToast from "../../../components/_utils/CommonToast/index.jsx";
import SVGComponent from "../../../components/_utils/SVGComponent/index.jsx";
import MisCreateConfirm from "../../../components/MIS_Report/MisCreateConfirm";
import MisCreateSelectFilter from "../../../components/MIS_Report/MisCreateSelectFilter";
import MisCreateSelection from "../../../components/MIS_Report/MisCreateSelection";
import SelectColumns from "../../../components/MIS_Report/MisCreateSorting";
import { IntervalConfiguration } from "../../../utils/configurationProvider";
import TEXT from "../../../utils/globalText.js";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";

const MisReportCreateComponent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [activeStep, setActiveStep] = useState(0);
  const [slideAnimation, setSlideAnimation] = useState(false);
  const [direction, setDirection] = useState(null);
  const [removeClassName, setRemoveClassName] = useState(true);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [isOpen, _setIsOpen] = useState(false);
  const [isDateConfirmed, setIsDateConfirmed] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [endDateConfirm, setendDateConfirm] = useState(null);
  const [startDateConfirm, setstartDateConfirm] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(() => {
    const path = window.location.pathname;

    switch (true) {
      case path.includes("internal_transaction_dashboard"):
        return "Internal transaction";

      case path.includes("beneficiary_transaction_dashboard"):
        return "Beneficiary transaction";

      case path.includes("owner_account_dashboard"):
        return "Bank statement";

      case path.includes("private_transaction_dashboard"):
        return "Private transaction";

      default:
        return "";
    }
  });
  const [dropdownStates, setDropdownStates] = useState({
    dropdown1: false,
    dropdown2: false,
  });
  const [selectedValues, setSelectedValues] = useState({
    dropdown1: "",
    dropdown2: "",
  });
  const [filterMapping, setFilterMapping] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [columnsData, setColumnsData] = useState([
    { columnId: "col-1", columnName: "Entity ID", selected: false },
    { columnId: "col-2", columnName: "Category", selected: false },
    { columnId: "col-3", columnName: "Distribution remark", selected: false },
    { columnId: "col-4", columnName: "Payment method", selected: false },
    { columnId: "col-5", columnName: "Amount", selected: false },
    {
      columnId: "col-6",
      columnName: "Confidential transaction",
      selected: false,
    },
    { columnId: "col-7", columnName: "Approval status", selected: false },
    { columnId: "col-8", columnName: "Distribution status", selected: false },
  ]);
  const [buttonStatus, setButtonStatus] = useState({
    selectAllColumn: false,
    columnConfirm: true,
    sortConfirm: true,
  });
  const [isFirstConfirmed, setIsFirstConfirmed] = useState(false);
  const [isSortConfirmed, setIsSortConfirmed] = useState(false);
  const [nextButtonEnabled, BenEnableNextButton] = useState(false);
  const steps = [
    TEXT.SELECT_FIELD_DETAILS,
    TEXT.SELECT_COLUMNS,
    TEXT.FILTER_COLUMNS_OPTIONAL,
    TEXT.CONFIRM_AND_GENERATE,
  ];
  const [isMounted, setIsMounted] = useState(true);
  // const { shouldRender, animationClass } = useCustomHook(
  //   isMounted,
  //   270,
  //   direction,
  // );

  const animationClass =
    direction === "next" ? "animate-slide-next" : "animate-slide-prev";

  const sortOptions = ["Ascending", "Descending"];

  // Helper functions from MisCreateStepper
  const handleDateformat = (dates) => {
    const date = new Date(dates);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
  };

  const handleCreateStatus = (name) => {
    return [
      "distribution_complete",
      "created",
      "approved",
      "awaiting_funds",
      "distribution_initiated",
      "distribution_pending",
      "rejected",
      "failed",
      "reversal",
      "denied",
      "abandoned",
    ].map((itm) => {
      return {
        field: "distribution_lifecycle_status",
        include_value: name === "Include" ? itm : "",
        exclude_value: name === "Exclude" ? itm : "",
      };
    });
  };

  const getApprovalStatus = (name) => {
    return ["approved", "pending", "rejected", "abandoned", "blocked"].map(
      (itm) => {
        return {
          field: "lifecycle_status",
          include_value: name === "Include" ? itm : "",
          exclude_value: name === "Exclude" ? itm : "",
        };
      },
    );
  };

  const getDistributionStatus = (status, criteria_name) => {
    switch (status) {
      case "distribution complete":
        return "distribution_complete";
      case "distribution created":
        return "created";
      case "distribution initiated":
        return "distribution_initiated";
      case "distribution approved":
        return "approved";
      case "distribution pending":
        return "distribution_pending";
      case "awaiting funds":
        return "awaiting_funds";
      case "distribution reversal":
        return "reversal";
      case "distribution denied":
        return "denied";
      case "distribution rejected":
        return "rejected";
      case "distribution failed":
        return "failed";
      case "distribution abandoned":
        return "abandoned";
      case "all":
        return handleCreateStatus(criteria_name);
      default:
        return status;
    }
  };

  const getHandleColoums = (status) => {
    // Handle User field columns
    if (selectedOption === "User") {
      switch (status) {
        case "User name":
          return "user_full_name";
        case "Beneficiary account created":
          return "total_beneficiary_account_created_count";
        case "Beneficiary transaction created":
          return "total_beneficiary_transaction_created_count";
        case "Beneficiary transaction approved":
          return "total_beneficiary_transaction_approved_count";
        case "Internal transaction created":
          return "total_internal_transaction_created_count";
        case "Internal transaction approved":
          return "internal_transaction_approved_count";
        default:
          return status.toLowerCase().replace(/\s+/g, "_");
      }
    }

    // Handle Bank statement field columns
    if (selectedOption === "Bank statement") {
      switch (status) {
        case "Account Id":
          return "account_id";
        case "Opening balance":
          return "opening_balance";
        case "Closing balance":
          return "closing_balance";
        case "Account statement entry date":
          return "account_statement_entry_date";
        default:
          return status.toLowerCase().replace(/\s+/g, "_");
      }
    }

    // Handle other field columns
    switch (status) {
      case "Entity ID":
        return "entity_id";
      case "Category":
        return "category";
      case "Distribution remark":
        return "distribution_remark";
      case "Payment method":
        return "payment_method";
      case "Amount":
        return "amount";
      case "Confidential transaction":
        return "confidential_transaction";
      case "Approval status":
        return "lifecycle_status";
      case "Distribution status":
        return "distribution_lifecycle_status";
      default:
        return status;
    }
  };

  // Throttle function
  const throttle = (func, delay) => {
    let inThrottle = false;
    return function (...args) {
      if (!inThrottle) {
        func.apply(this, args);
        inThrottle = true;
        setTimeout(() => (inThrottle = false), delay);
      }
    };
  };

  const showToast = (message) => {
    CommonToast({
      text: message,
      icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
      variant: "var(--processing)",
      buttonNeeded: false,
      btnProps: {
        enabledBgColor: "var(--primary-bg)",
        enabledTextColor: "var(--text-primary)",
        btnText: "",
        handleFunction: () => {},
        icon: "",
        btnType: "button",
        isDisabled: false,
        hoverOption: "white",
      },
    });
  };

  // Main API call function
  const handleCreateBiller = async () => {
    setLoading(true);
    const selectedColumns = columnsData
      ?.filter((col) => col.selected)
      ?.map((itm) => getHandleColoums(itm.columnName));

    let sortdata = {};
    sortdata["field"] = getHandleColoums(selectedValues?.dropdown1) || "";
    sortdata["order"] =
      selectedValues?.dropdown2 === "Ascending" ? "asc" : "desc" || "";

    let val = [];

    let filterData =
      filterMapping?.map((itm) => {
        if (
          itm.input_value === "all" &&
          itm.column_name === "Distribution status"
        ) {
          let d = getDistributionStatus(itm.input_value, itm.criteria_name);
          val = [...val, ...d];
          return null;
        } else if (
          itm.input_value === "all" &&
          itm.column_name === "Approval status"
        ) {
          let d = getApprovalStatus(itm.criteria_name);
          val = [...val, ...d];
          return null;
        } else {
          return {
            field: getHandleColoums(itm.column_name),
            include_value:
              itm.criteria_name === "Include"
                ? itm.column_name === "Distribution status"
                  ? getDistributionStatus(itm.input_value, itm.criteria_name)
                  : itm.column_name === "Approval status"
                    ? itm.input_value
                    : itm.column_name === "Confidential transaction"
                      ? true
                      : itm.input_value
                : "",
            exclude_value:
              itm.criteria_name === "Exclude"
                ? itm.column_name === "Distribution status"
                  ? getDistributionStatus(itm.input_value, itm.criteria_name)
                  : itm.column_name === "Approval status"
                    ? itm.input_value
                    : itm.column_name === "Confidential transaction"
                      ? true
                      : itm.input_value
                : "",
            max_value: itm.criteria_name === "Maximum" ? itm.input_value : "",
            min_value: itm.criteria_name === "Minimum" ? itm.input_value : "",
          };
        }
      }) || [];

    filterData = [...filterData, ...val]?.filter((itm) => itm !== undefined);

    const payload = {
      report_details: {
        report_type:
          selectedOption === "Beneficiary transaction"
            ? "beneficiary_transaction"
            : selectedOption === "User"
              ? "user"
              : selectedOption === "Bank statement"
                ? "statement"
                : "internal_transaction",
        selected_columns: selectedColumns,
        date_from:
          startDateConfirm && endDateConfirm
            ? handleDateformat(startDateConfirm)
            : undefined,
        date_to:
          startDateConfirm && endDateConfirm
            ? handleDateformat(endDateConfirm)
            : undefined,
      },
      filters: filterData.length > 0 ? filterData : undefined,
      sort_by:
        selectedValues?.dropdown1 !== "" && selectedValues?.dropdown2 !== ""
          ? [sortdata]
          : undefined,
    };

    sessionStorage.setItem("MisPayload", JSON.stringify(payload));
    sessionStorage.setItem("Misfromdate", JSON.stringify(startDateConfirm));
    sessionStorage.setItem("Mistodate", JSON.stringify(endDateConfirm));
    showToast("Generating report");
    const res = await dispatch(
      MisReportCreateDownload({
        payload,
      }),
    );

    if (res.meta.requestStatus === "fulfilled" && res.payload === true) {
      toast.dismiss();
      CommonToast({
        text: "Report generated and download started.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      setLoading(false);
      navigate(-1);
    } else {
      setLoading(false);
    }
  };

  const throttledHandleCreateTransaction = throttle(handleCreateBiller, 5000);

  const hasAdditionalColumnsSelected = useCallback(() => {
    if (selectedOption === "User") {
      const selectedColumns = columnsData.filter(
        (data) => data?.selected === true,
      );
      return (
        selectedColumns.length > 1 ||
        (selectedColumns.length === 1 &&
          selectedColumns[0].columnName !== "User name")
      );
    } else if (selectedOption === "Bank statement") {
      const selectedColumns = columnsData.filter(
        (data) => data?.selected === true,
      );
      return (
        selectedColumns.length > 1 ||
        (selectedColumns.length === 1 &&
          selectedColumns[0].columnName !== "Account Id")
      );
    } else {
      return columnsData.some((data) => data?.selected === true);
    }
  }, [selectedOption, columnsData]);

  const toggleDropdown = (dropdownKey) => {
    setDropdownStates((prevState) => ({
      ...prevState,
      [dropdownKey]: !prevState[dropdownKey],
    }));
  };

  const handleOptionSelect = (dropdownKey, option) => {
    setSelectedValues((prevValues) => {
      const newValues = {
        ...prevValues,
        [dropdownKey]: option,
      };

      if (dropdownKey === "dropdown1") {
        newValues.dropdown2 = "";
      }

      return newValues;
    });
    toggleDropdown(dropdownKey);
    // Auto-confirm sort for all field types when both dropdowns are selected
    setTimeout(() => {
      const currentValues = { ...selectedValues, [dropdownKey]: option };
      if (dropdownKey === "dropdown1") {
        currentValues.dropdown2 = "";
      }
      const hasValidSort =
        currentValues.dropdown1 !== "" && currentValues.dropdown2 !== "";
      if (hasValidSort) {
        setButtonStatus((previosData) => ({
          ...previosData,
          sortConfirm: false,
        }));
        setIsSortConfirmed(true);
      }
    }, 100);
  };

  const handleClearFilter = (dropdownKey, e) => {
    e.stopPropagation();
    setSelectedValues((prevValues) => ({
      ...prevValues,
      [dropdownKey]: "",
    }));
  };

  const handleSelectColumn = (selectedId) => {
    setColumnsData((previousData) => {
      return previousData?.map((result) => {
        if (
          (selectedOption === "User" && result.columnName === "User name") ||
          (selectedOption === "Bank statement" &&
            result.columnName === "Account Id")
        ) {
          return { ...result, selected: true };
        }

        if (result?.columnId === selectedId) {
          const updatedColumn = { ...result, selected: !result?.selected };

          return updatedColumn;
        } else {
          return result;
        }
      });
    });

    setSelectedValues({
      dropdown1: "",
      dropdown2: "",
    });

    setButtonStatus((prev) => ({
      ...prev,
      columnConfirm: false,
      sortConfirm: true,
    }));

    setIsSortConfirmed(false);
    setIsFirstConfirmed(true);
  };

  const handleSelectAllColumn = () => {
    if (buttonStatus?.selectAllColumn) {
      setColumnsData((previousData) => {
        return previousData?.map((result) => {
          if (selectedOption === "User" && result.columnName === "User name") {
            return { ...result, selected: true };
          }
          if (
            selectedOption === "Bank statement" &&
            result.columnName === "Account Id"
          ) {
            return { ...result, selected: true };
          }
          return { ...result, selected: false };
        });
      });
      setButtonStatus((previosData) => {
        return {
          ...previosData,
          selectAllColumn: false,
          columnConfirm: false,
          sortConfirm: true,
        };
      });
    } else {
      setColumnsData((previousData) => {
        return previousData?.map((result) => {
          return { ...result, selected: true };
        });
      });
      setButtonStatus((previosData) => {
        return {
          ...previosData,
          selectAllColumn: true,
          columnConfirm: false,
          sortConfirm: true,
        };
      });
    }
    // Auto-confirm for select all - similar to handleSelectColumn
    setTimeout(() => {
      setIsFirstConfirmed(true);
      setIsSortConfirmed(false);
    }, 100);
  };

  const handleClearColumns = () => {
    setColumnsData((previousData) =>
      previousData.map((result) => {
        if (selectedOption === "User" && result.columnName === "User name") {
          return { ...result, selected: true };
        }
        if (
          selectedOption === "Bank statement" &&
          result.columnName === "Account Id"
        ) {
          return { ...result, selected: true };
        }
        return { ...result, selected: false };
      }),
    );
    setButtonStatus((previosData) => ({
      ...previosData,
      columnConfirm: true,
      selectAllColumn: false,
    }));
    setIsFirstConfirmed(false);
  };

  const handeleColumnConfirm = () => {
    setSelectedValues((prevValues) => ({
      ...prevValues,
      dropdown1: "",
      dropdown2: "",
    }));

    setButtonStatus((previosData) => ({
      ...previosData,
      columnConfirm: false,
      sortConfirm: true,
    }));

    setIsSortConfirmed(false);
    setIsFirstConfirmed(true);
    setFilterMapping([]);
  };

  const handleEditSelectedColumns = () => {
    setButtonStatus((previosData) => {
      return { ...previosData, columnConfirm: true };
    });
  };

  const handleClearSort = () => {
    setSelectedValues((prevValues) => ({
      ...prevValues,
      dropdown1: "",
      dropdown2: "",
    }));
    setButtonStatus((previosData) => ({
      ...previosData,
      sortConfirm: true,
    }));
    setIsSortConfirmed(false);
  };

  const handleSortConfirm = () => {
    if (selectedValues.dropdown1 !== "" && selectedValues.dropdown2 !== "") {
      setButtonStatus((previosData) => {
        return { ...previosData, sortConfirm: false };
      });
      setIsSortConfirmed(true);
    }
  };

  const handleEditSort = () => {
    setButtonStatus((previosData) => {
      return { ...previosData, sortConfirm: true };
    });
  };

  const selectedColumns = columnsData.filter((col) => col.selected);

  const toggleMounting = () => {
    setIsMounted(false);
    setTimeout(() => {
      setIsMounted(true);
    }, 270);
  };
  const handleNext = () => {
    // If we're on step 3 (confirm page), call the API instead of going to next step
    if (activeStep === 3) {
      throttledHandleCreateTransaction();
      return;
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setDirection("next");
    toggleMounting();
    setRemoveClassName(false);
    setTimeout(() => {
      setRemoveClassName(true);
    }, IntervalConfiguration.intervalSemiMid);
  };
  const handleBack = () => {
    if (activeStep === 0) {
      navigate(-1);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
      setDirection("previous");
      toggleMounting();
      setRemoveClassName(false);
      setTimeout(() => {
        setRemoveClassName(true);
      }, IntervalConfiguration.intervalSemiMid);
      setTimeout(() => {
        setDirection(null);
      }, 500);
    }
  };

  const getFilteredColumns = (option) => {
    const allColumns = [
      { columnId: "col-1", columnName: "Entity ID", selected: false },
      { columnId: "col-2", columnName: "Category", selected: false },
      { columnId: "col-3", columnName: "Distribution remark", selected: false },
      { columnId: "col-4", columnName: "Payment method", selected: false },
      { columnId: "col-5", columnName: "Amount", selected: false },
      {
        columnId: "col-6",
        columnName: "Confidential transaction",
        selected: false,
      },
      { columnId: "col-7", columnName: "Approval status", selected: false },
      { columnId: "col-8", columnName: "Distribution status", selected: false },
    ];

    const userColumns = [
      {
        columnId: "user-col-1",
        columnName: "User name",
        selected: true,
        isDefault: true,
      },
      {
        columnId: "user-col-2",
        columnName: "Beneficiary account created",
        selected: false,
      },
      {
        columnId: "user-col-3",
        columnName: "Beneficiary transaction created",
        selected: false,
      },
      {
        columnId: "user-col-4",
        columnName: "Beneficiary transaction approved",
        selected: false,
      },
      {
        columnId: "user-col-5",
        columnName: "Internal transaction created",
        selected: false,
      },
      {
        columnId: "user-col-6",
        columnName: "Internal transaction approved",
        selected: false,
      },
    ];

    const bankStatementColumns = [
      {
        columnId: "bank-col-1",
        columnName: "Account Id",
        selected: true,
        isDefault: true,
      },
      {
        columnId: "bank-col-2",
        columnName: "Opening balance",
        selected: false,
      },
      {
        columnId: "bank-col-3",
        columnName: "Closing balance",
        selected: false,
      },
      {
        columnId: "bank-col-4",
        columnName: "Account statement entry date",
        selected: false,
      },
    ];

    if (option === "User") {
      return userColumns;
    }

    if (option === "Bank statement") {
      return bankStatementColumns;
    }

    if (option === "Internal transaction") {
      return allColumns.filter((column) => column.columnName !== "Category");
    }

    return allColumns;
  };

  const dataArray = [
    {
      previousText: TEXT.CANCEL,
      nextText: TEXT.NEXT,
      previousEnableBgColor: "var(--primary-act)",
      nextEnableBgColor: "var(--text-primary)",
      nextEnableTextColor: "var(--primary-bg)",
      nextHoverOption: "black",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextIsLoading: false,
      nextIsEnabled: nextButtonEnabled,
      stepperText: TEXT.SELECT_FIELD_DETAILS,
    },
    {
      previousText: TEXT.PREVIOUS,
      nextText: TEXT.NEXT,
      previousEnableBgColor: "var(--primary-act)",
      nextEnableBgColor: "var(--text-primary)",
      nextEnableTextColor: "var(--primary-bg)",
      nextHoverOption: "black",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextIsLoading: false,
      nextIsEnabled: nextButtonEnabled,
      stepperText: TEXT.SELECT_COLUMNS,
    },
    {
      previousText: TEXT.PREVIOUS,
      nextText: TEXT.NEXT,
      previousEnableBgColor: "var(--primary-act)",
      nextEnableBgColor: "var(--text-primary)",
      nextHoverOption: "black",
      nextEnableTextColor: "var(--primary-bg)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextIsLoading: false,
      nextIsEnabled: nextButtonEnabled,
      stepperText: TEXT.FILTER_COLUMNS_OPTIONAL,
      extraInfoHeaderText: TEXT?.FILTER_BY_OPTIONAL_CAMELCASE,
      extraInfoSubText: TEXT?.FILTER_COLUMN_INFO,
      extraInfoShow: !filterMapping?.length > 0 && activeStep === 2,
    },
    {
      previousText: TEXT.PREVIOUS,
      nextText: "Download",
      previousEnableBgColor: "var(--primary-act)",
      nextHoverOption: "black",
      nextEnableBgColor: "var(--positive-act)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextIsLoading: loading,
      nextIsEnabled: nextButtonEnabled,
      nextLoaderNeeded: true,
      stepperText: "Confirm and download",
    },
  ];

  const renderBillerForms = () => {
    switch (activeStep) {
      case 0:
        return (
          <MisCreateSelection
            BenEnableNextButton={BenEnableNextButton}
            activeStep={activeStep}
            direction={direction}
            setDirection={setDirection}
            BenEnableNextButton1={BenEnableNextButton}
            isOpen={_setIsOpen}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            setstartDateConfirm={setstartDateConfirm}
            setendDateConfirm={setendDateConfirm}
            endDateConfirm={endDateConfirm}
            startDateConfirm={startDateConfirm}
            setShowDatePicker={setShowDatePicker}
            showDatePicker={showDatePicker}
            isDateConfirmed={isDateConfirmed}
            setIsDateConfirmed={setIsDateConfirmed}
            isDropdownOpen={isDropdownOpen}
            setIsDropdownOpen={setIsDropdownOpen}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            setFilterMapping={setFilterMapping}
            setActiveTab={setActiveTab}
          />
        );
      case 1:
        return (
          <SelectColumns
            slideAnimation={slideAnimation}
            setSlideAnimation={setSlideAnimation}
            BenEnableNextButton={BenEnableNextButton}
            nextButtonEnabled={nextButtonEnabled}
            activeStep={activeStep}
            direction={direction}
            setDirection={setDirection}
            // Lifted state props
            dropdownStates={dropdownStates}
            setDropdownStates={setDropdownStates}
            selectedValues={selectedValues}
            setSelectedValues={setSelectedValues}
            columnsData={columnsData}
            setColumnsData={setColumnsData}
            buttonStatus={buttonStatus}
            setButtonStatus={setButtonStatus}
            isFirstConfirmed={isFirstConfirmed}
            setIsFirstConfirmed={setIsFirstConfirmed}
            isSortConfirmed={isSortConfirmed}
            setIsSortConfirmed={setIsSortConfirmed}
            sortOptions={sortOptions}
            selectedColumns={selectedColumns}
            // Lifted function props
            toggleDropdown={toggleDropdown}
            handleOptionSelect={handleOptionSelect}
            handleClearFilter={handleClearFilter}
            handleSelectColumn={handleSelectColumn}
            handleSelectAllColumn={handleSelectAllColumn}
            handleClearColumns={handleClearColumns}
            handeleColumnConfirm={handeleColumnConfirm}
            handleEditSelectedColumns={handleEditSelectedColumns}
            handleClearSort={handleClearSort}
            handleSortConfirm={handleSortConfirm}
            handleEditSort={handleEditSort}
            selectedOption={selectedOption}
          />
        );

      case 2:
        return (
          <MisCreateSelectFilter
            direction={direction}
            setDirection={setDirection}
            setFilterMapping={setFilterMapping}
            filterMapping={filterMapping}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            columnsData={columnsData}
            selectedOption={selectedOption}
          />
        );
      case 3:
        return (
          <MisCreateConfirm
            selectedOption={selectedOption}
            startDate={startDateConfirm}
            endDate={endDateConfirm}
            columnsData={columnsData}
            selectedValues={selectedValues}
            filterMapping={filterMapping}
            direction={direction}
            setDirection={setDirection}
          />
        );
      default:
        return null;
    }
  };

  // Keyboard event handling for Enter key on step 3
  useEffect(() => {
    const handleEnterKeyPress = (e) => {
      if (e.key === "Enter" && activeStep === 3) {
        e.preventDefault();
        throttledHandleCreateTransaction();
      }
    };

    document.addEventListener("keydown", handleEnterKeyPress);
    return () => {
      document.removeEventListener("keydown", handleEnterKeyPress);
    };
  }, [activeStep, throttledHandleCreateTransaction]);

  useEffect(() => {
    let nxBtnenable;
    if (activeStep === 0) {
      nxBtnenable = selectedOption !== "" && startDateConfirm && endDateConfirm;
    } else if (activeStep === 1) {
      nxBtnenable =
        selectedOption === "User" ||
        selectedOption === "Bank statement" ||
        (hasAdditionalColumnsSelected() &&
          !buttonStatus.columnConfirm &&
          !buttonStatus.sortConfirm &&
          Object.values(selectedValues).every((itm) => itm !== "")) ||
        (hasAdditionalColumnsSelected() &&
          !buttonStatus.columnConfirm &&
          Object.values(selectedValues).every((itm) => itm === ""));
    } else if (activeStep === 2) {
      nxBtnenable = filterMapping.every((itm) => !itm.active);
    } else if (activeStep === 3) {
      // For the confirm page, always enable the generate button
      nxBtnenable = true;
    }
    BenEnableNextButton(nxBtnenable);
  }, [
    activeStep,
    selectedOption,
    startDate,
    endDate,
    filterMapping,
    columnsData,
    selectedValues,
    buttonStatus,
    startDateConfirm,
    endDateConfirm,
    hasAdditionalColumnsSelected,
  ]);

  useEffect(() => {
    if (columnsData.every((data) => data?.selected === true)) {
      setButtonStatus((previosData) => {
        return { ...previosData, selectAllColumn: true };
      });
    } else if (columnsData.some((data) => data?.selected === false)) {
      setButtonStatus((previosData) => {
        return { ...previosData, selectAllColumn: false };
      });
    }
  }, [columnsData]);

  useEffect(() => {
    const currentlySelectedNames = columnsData
      .filter((col) => col.selected)
      .map((col) => col.columnName);

    const invalidFilterIndex = filterMapping.findIndex(
      (filter) =>
        filter.column_name &&
        !currentlySelectedNames.includes(filter.column_name),
    );

    if (invalidFilterIndex !== -1) {
      setFilterMapping((prevMapping) =>
        prevMapping.filter((filter, idx) => {
          if (idx !== invalidFilterIndex) {
            return filter;
          }
        }),
      );
      setActiveTab(invalidFilterIndex);
    }
  }, [columnsData]);

  useEffect(() => {
    const hasSelected = columnsData.some((col) => col.selected);

    if (!hasSelected) {
      setSelectedValues({
        dropdown1: "",
        dropdown2: "",
      });

      setButtonStatus((prev) => ({
        ...prev,
        sortConfirm: true,
      }));

      setIsSortConfirmed(false);
    }
  }, [columnsData]);

  useEffect(() => {
    const filteredColumns = getFilteredColumns(selectedOption);
    setColumnsData(filteredColumns);

    setSelectedValues({
      dropdown1: "",
      dropdown2: "",
    });
    setButtonStatus((prev) => ({
      ...prev,
      columnConfirm: true,
      sortConfirm: true,
    }));
    setIsFirstConfirmed(false);
    setIsSortConfirmed(false);
    setFilterMapping([]);
    setActiveTab(0);
  }, [selectedOption]);

  return (
    <div className="Mis_report_Container_txn">
      <div className="Qsmd:min-h-navbar-breadcrumb-height w-full Qlg:bg-transparent bg-primary-nav"></div>
      <div
        className={`Mis_report_stepper_Div ${!filterMapping?.length > 0 && activeStep === 2 ? "Qsmd:min-h-stepper-header min-h-stepper-height" : "min-h-stepper-height"}`}
      >
        <PrimaryStepper
          activeStep={activeStep}
          handleForwardAction={handleNext}
          handleBackwardAction={handleBack}
          dataArray={dataArray}
        />
      </div>
      <>
        <div className="flex items-center w-full-width bg-primary-nav Qsmd:hidden  z-z-index-header shadow-box-shadow-bottom">
          <TopNavComponent
            isFormattingNotRequired={true}
            topNavHeader={"Generate MIS"}
            topNavSubText="Select field details"
          />
        </div>
      </>

      {!filterMapping?.length > 0 && activeStep === 2 && (
        <div className="bg-primary-nav w-full Qsmd:hidden">
          <div
            style={{ maxWidth: "var(--max-content-width)" }}
            className=" w-full mx-auto border-t-border border-primary-bg pl-padding-sm Qmd:pl-padding-base   "
          >
            <div className="py-padding-button-l flex flex-col gap-gap-xs">
              <div className="w-full flex flex-col h-fit">
                <p className="font-normal text-font-sm  text-text-primary">
                  Filter By <span className="font-normal ">(Optional)</span>
                </p>
              </div>
              <p className="text-font-xs h-fit text-text-secondary">
                No filter added. Click ‘Add filter’ to select and apply a filter
                to this report.
              </p>
            </div>
          </div>
        </div>
      )}

      <div
        className={`mis_carousel-container w-full ${!filterMapping?.length > 0 && activeStep === 2 ? "" : "pt-padding-lg"}`}
      >
        <div
          style={{
            margin: "var(--margin-base) auto",
            maxWidth: "var(--max-content-width)",
          }}
          className={`${
            activeStep === 0 && direction === "next"
              ? ""
              : removeClassName === true
                ? ""
                : animationClass
          }  w-full  mb-margin-md  Qmd:mb-margin-sm pb-padding-xl`}
        >
          {renderBillerForms()}
        </div>
      </div>
      <div className="block Qsmd:hidden h-pagination-height"></div>
    </div>
  );
};

export default MisReportCreateComponent;
